module.exports = __webpack_public_path__ + "img/ic_heart.eb7f0d71.svg";